export default __webpack_public_path__ + "static/media/karmayogi-volunteer-pac1.951c6124.jpeg";